import Publisher from 'types/Publisher';

const publishersWithoutSms = (publishers: Publisher[]) =>
  publishers.filter((publisher) => {
    const sms = publisher.contactMethods.filter((cm) => cm.protocol === 'sms');
    return !sms.length;
  });

export default publishersWithoutSms;
